import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'underscore';

import { Link as ReactLink } from 'react-router-dom';

import {
    List,
    ListItem,
    Title,
    Grid,
} from 'yurstrap';

import { extractQueryParameters } from 'helpers/RoutesHelpers';
import ModalLink from '../../../components/ModalLink';
import BackLink from '../BackLink';

import { getSearchSelector, getPathnameSelector } from '../../../commons/selectors/RouterSelector';

import Routes from '../../constants/Routes';

import { getScopeSelector } from '../../../commons/reduxModules/Authentication';
import Scopes from '../../../constants/Scopes';

const propTypes = {
    pathname: PropTypes.string.isRequired,
    scope: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
    sidebarItems: PropTypes.array,
};

const defaultProps = {
    sidebarItems: [{
        key: 1,
        link: Routes.FAQ_PAGE.link,
        title: 'FAQ',
        info: 'Trouvez ici les réponses à vos questions.',
    }, {
        key: 2,
        link: Routes.CONTACT_BY_EMAIL.link,
        title: 'Email',
        info: 'Vous n\'avez pas trouvé de réponse dans la FAQ ? Contactez notre support par email !',
    }, {
        key: 3,
        link: Routes.CONTACT_SALESMAN.link,
        title: 'Chargé de projet',
        info: 'Demandez un rendez-vous d\'accompagnement personnalisé',
    }],
};

class SideBar extends Component {

    renderItem(sidebarItem) {
        const {
            pathname,
            scope,
            search,
        } = this.props;
        const linkProps = {
            componentClass: ReactLink,
        };
        let modalPathname = '';
        if (Scopes.USER !== scope) {
            linkProps.componentClass = ModalLink;
            linkProps.modalName = 'support';
            modalPathname = extractQueryParameters(search)['support-modal'];
        }
        return (
            <ListItem
                key={sidebarItem.key}
                inner
                active={sidebarItem.link === (Scopes.USER === scope ? pathname : modalPathname)}
                className="px-3 py-1"
                style={{ height: '150px' }}
            >
                <Grid
                    to={sidebarItem.link}
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...linkProps}
                >
                    <Title>
                        {sidebarItem.title}
                    </Title>
                    <p className="u-font-size--3 u-font-weight--regular u-color__grey--60">
                        {sidebarItem.info}
                    </p>
                </Grid>
            </ListItem>
        );
    }

    render() {
        const {
            pathname,
            sidebarItems,
        } = this.props;
        const items = _.map(sidebarItems, this.renderItem, this);
        return (
            <div className={`u-col--m-5 u-col--s-12 px-4 px--s-3 py-5 u-bg__grey--20 ${pathname === Routes.SUPPORT_ROOT.link ? '' : 'u-display__none--s u-display__none--m'}`} style={{ height: '720px' }}>
                <BackLink />
                <List className="u-text-align__center" style={{ paddingTop: '70px' }}>
                    {items}
                </List>
            </div>
        );
    }

}

SideBar.propTypes = propTypes;

SideBar.defaultProps = defaultProps;

function mapStateToProps(state) {
    return {
        search: getSearchSelector(state),
        pathname: getPathnameSelector(state),
        scope: getScopeSelector(state),
    };
}

export default connect(
    mapStateToProps,
)(SideBar);
